<div class="licenses-page">
  <div class="licenses-page-header">
    <div class="title">Licenses</div>
  </div>
  <div class="licenses-page-body">
    <div class="licenses" *ngIf="!isLoading" [@inAnimation]>
      <div class="top-component">
        <mat-card>
          <div class="top-component__header">
            <div class="title">Licenses</div>
            <nrwl-helpicon class="help-icon" [helpId]="'licenses'"></nrwl-helpicon>
          </div>
          <div class="top-component__body">
            <div class="row">
              <span class="title">Version</span>
              <span class="text">{{versionNumber}}</span>
            </div>
            <div class="row">
              <span class="title">Locking Code</span>
              <span class="text" *ngIf="lockCodeObtained === 0"
                >Please wait.. Obtaining lock code..</span
              >
              <span class="text" *ngIf="lockCodeObtained === 1"
                >Lock code could not be obtained!</span
              >
              <span class="text" *ngIf="lockCodeObtained === 2">{{lockCode}}</span>
            </div>
            <div class="row">
              <div class="file-upload-container">
                <input
                  class="file-upload-input"
                  placeholder="Select file"
                  [value]="fileName"
                  (click)="file.click()"
                />
                <input #file type="file" (change)="onFilesAdded()" style="display: none" />
                <i
                  (click)="clearSelectedFile()"
                  *ngIf="showClearButton"
                  class="close-icon mdi mdi-close"
                ></i>
                <button class="input-btn btn-blue" *ngIf="!showClearButton" (click)="file.click()">
                  <i class="icon mdi mdi-folder-open"></i>
                </button>
                <button
                  class="input-btn btn-blue"
                  *ngIf="showClearButton"
                  (click)="saveLicenseFile()"
                  [disabled]="lockCodeObtained !== 2"
                >
                  <i class="icon mdi mdi-check"></i>
                </button>
              </div>
            </div>
            <div class="row">
              <mat-progress-bar
                class="file-upload-progress"
                *ngIf="uploading"
                mode="determinate"
                [value]="progress[fileName]?.progress | async"
              >
              </mat-progress-bar>
            </div>
            <div class="row" *ngIf="hasErrors()">
              <div class="error-message">
                <p class="message" *ngFor="let msg of errorForLicenseFile">{{msg}}<br /></p>
              </div>
            </div>
          </div>
        </mat-card>
      </div>

      <div class="bottom-component">
        <mat-card>
          <div class="bottom-component__header">
            <div class="title">Installed Licenses</div>
            <span>
              <button
                mat-raised-button
                class="refresh-btn btn-blue"
                (click)="refreshLicenseCount()"
              >
                REFRESH
              </button>
              <nrwl-helpicon class="help-icon" [helpId]="'installedLicenses'"></nrwl-helpicon>
            </span>
          </div>
          <div class="bottom-component__body">
            <div *ngIf="!showLicenseError && showLicenseAvailable" class="wrapper">
              <ng-container *ngFor="let license of activeLicenses">
                <nrwl-license-card [license]="license"></nrwl-license-card>
              </ng-container>
            </div>
            <div *ngIf="showLicenseError || !showLicenseAvailable">
              <div [ngClass]="{ 'license-error': showLicenseError }">
                <p [ngClass]="{ 'message': showLicenseError,'info-message':!showLicenseAvailable }">
                  {{errorRetrievalMsg}}<br />
                </p>
              </div>
            </div>
          </div>
        </mat-card>
      </div>
    </div>
    <progress-spinner *ngIf="isLoading"></progress-spinner>
  </div>
</div>
